import React from 'react';

export enum FilterButtonType {
    Blue,
    Orange,
}

interface FilterButtonProps {
    className?: string;
    onClick?: () => void;
    text?: string;
    isSelected?: boolean;
    type?: FilterButtonType;
}

export const FilterButton: React.FC<FilterButtonProps> = ({
    className = '',
    onClick,
    text = '',
    isSelected = false,
    type = FilterButtonType.Orange,
}) => {
    const commonClasses =
        'group inline-flex items-center justify-start gap-2 px-6 py-3 rounded-full transition-all';

    const borderClasses = isSelected
        ? type == FilterButtonType.Orange
            ? 'border-1 border-action-orange bg-action-orange-extralight'
            : 'border-1 border-secondary-blue-dark bg-secondary-blue-extralight'
        : 'border-1 border-gray-700 hover:bg-white';

    return (
        <button
            className={`${commonClasses} ${borderClasses} ${className}`}
            onClick={onClick}
        >
            <span className="text-primary-blue font-semibold">{text}</span>
        </button>
    );
};
